import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { useTranslation } from "react-i18next";

export function useRemoteUpdateEquipment() {
  const { t } = useTranslation();
  return useRemoteMutation<void, RemoteApiError, FormData>({
    key: "update-equipment",
    url: "/equipment-inventory",
    method: "patch",
    snackbarTextOnSuccess: t("Successfully updated an equipment"),
    snackbarTextFunOnFail: error => `${(error as any).response.data.message}`
  });
}
